export default __webpack_public_path__ + "static/media/avatar-normal-geometric-17.aecedf8c.svg";